import { createSelector } from 'reselect'
import { getByIdExerciseSelector } from '@gymaholic/packages'
import getEquipmentStrByIdExerciseSelectorUtil from 'modules/exercise/redux/selectors/get-equipment-str-by-id/utils/index.js'

/**
 * @param id
 * @param intl
 * @param isShort
 * @return {OutputSelector<unknown, string|*, (res: *) => (string|*)>}
 */
function getEquipmentStrByIdExerciseSelector ({
  id,
  intl,
  isShort
}) {
  return createSelector(
    getByIdExerciseSelector(id),
    (exercise) => getEquipmentStrByIdExerciseSelectorUtil({
      exercise,
      intl,
      isShort
    })
  )
}

export default getEquipmentStrByIdExerciseSelector
